module.exports = __webpack_public_path__ + "img/down@2x.1ab261b4.png";